import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

const DELETE_INGREDIENT_SPECIAL_CASE_MUTATION = gql`
  mutation deleteIngredientSpecialCase($id: ID!) {
    deleteIngredientSpecialCase(id: $id) {
      id
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
`

export default DELETE_INGREDIENT_SPECIAL_CASE_MUTATION
